module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-4"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BBREVIATIONS")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-1"
    }
  }, [_c('em', [_vm._v("Primary Sources")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BGU")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ägyptische Urkunden aus den Königlichen Staatlichen Museen zu Berlin, Griechische Urkunden")]), _vm._v(". 19 vols. Berlin: Weidmann, 1895–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CIL")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Corpus Inscriptionum Latinarum")]), _vm._v(". 17 vols. Berlin, 1862–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CCSL")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Corpus Christianorum: Series Latina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IG")]), _vm._v(" XII")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Inscriptiones Graecae")]), _vm._v(", XII: "), _c('em', [_vm._v("Inscriptiones insularum maris Aegaei praeter Delum: 4. Inscriptiones Coi, Calymnae, Insularum Milesiarum.")]), _vm._v(" Edited by Dimitris Bosnakis and Klaus Hallof. Berlin: de Gruyter, 2012")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("IKosPH")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Paton, William R., and Edward L. Hicks, eds. "), _c('em', [_vm._v("The Inscriptions of Cos")]), _vm._v(". Oxford, 1891. Reprint: Hildesheim, 1990")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("IRhodM")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Maiuri, Amedeo, ed. "), _c('em', [_vm._v("Nuova silloge epigrafica di Rodi e Cos")]), _vm._v(". Florence: Le Monnier, 1925")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Iscr. di Cos")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Iscrizioni di Cos")]), _vm._v(". Edited by Mario Segre. Monografie della Scuola Archeologica di Atene e delle Missioni Italiane in Oriente, 6. Rome: L’Erma di Bretschneider, 1993")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kent")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kent, John Harvey. "), _c('em', [_vm._v("The Inscriptions: 1926–1950")]), _vm._v(". Vol. 8.3 of "), _c('em', [_vm._v("Corinth: Results of Excavations Conducted by the American School of Classical Studies at Athens")]), _vm._v(". Princeton: The American School of Classical Studies at Athens, 1966")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OECT")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Oxford Early Christian Texts")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TAM")]), _vm._v(" II")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kalinka Ernst, ed. "), _c('em', [_vm._v("Tituli Lyciae linguis Graeca et Latina conscripti.")]), _vm._v(" Vol. 2 of "), _c('em', [_vm._v("Tituli Asiae Minoris.")]), _vm._v(" Vienna: Hölder, 1920–1944")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TGV")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Η Αγία Γραφή στη Δημοτική (Today’s Greek Version). Athens: Hellenic Bible Society, 1997")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("West")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("West, Allen Brown. "), _c('em', [_vm._v("Latin Inscriptions: 1896–1926.")]), _vm._v(" Vol. 8.2 of "), _c('em', [_vm._v("Corinth: Results of Excavations Conducted by the American School of Classical Studies at Athens.")]), _vm._v(" Cambridge: Harvard University Press for the American School of Classical Studies at Athens, 1931")])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-2"
    }
  }, [_c('em', [_vm._v("Secondary Sources and Reference Works")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AAR")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("American Academy of Religion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AGG")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("von Siebenthal, Heinrich. "), _c('em', [_vm._v("Ancient Greek Grammar for the Study of the New Testament")]), _vm._v(". Oxford: Lang, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BABESCH")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin Antieke Beschaving")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BARIS")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BAR (British Archaeological Reports) International Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDAG")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Danker, Frederick W., Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. "), _c('em', [_vm._v("Greek-English Lexicon of the New Testament and Other Early Christian Literature")]), _vm._v(". 3rd ed. Chicago: University of Chicago Press, 2000. Numbers refer to the entries of the digital version of BibleWorks.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BECNT")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Baker Exegetical Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BTZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Berliner Theologische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Currents in Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CCSL")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Corpus Christianorum: Series Latina. Turnhout: Brepols, 1953–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CGL")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Diggle, James, ed. "), _c('em', [_vm._v("The Cambridge Greek Lexicon")]), _vm._v(". Cambridge: Cambridge University Press, 2021")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Classical Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ClQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Classical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ECL")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Early Christianity and Its Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("EKKNT")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Evangelisch-katholischer Kommentar zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ETL")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ephemerides Theologicae Lovanienses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FB")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschung zur Bibel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("GR")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Greece and Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HNT")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Handbuch zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JRS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Roman Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSNTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("L&N")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Louw, Johannes P., and Eugene A. Nida, eds. "), _c('em', [_vm._v("Greek-English Lexicon of the New Testament: Based on Semantic Domains.")]), _vm._v(" 2nd ed. New York: United Bible Societies, 1989")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LNTS")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Library of New Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LSJM")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Liddell, Henry G., and Robert Scott. "), _c('em', [_vm._v("A Greek-English Lexicon.")]), _vm._v(" Revised and supplemented by H. S. Jones with the help of von R. McKenzie. 9th ed. with revised supplement. Oxford: Clarendon, 1996. Numbers refer to the entries of the online version: "), _c('a', {
    attrs: {
      "href": "http://stephanus.tlg.uci.edu/lsj",
      "target": "_blank"
    }
  }, [_vm._v("http://stephanus.tlg.uci.edu/lsj/")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NAC")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New American Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Neot")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Neotestmentica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NIB")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Keck, Leander E., ed. "), _c('em', [_vm._v("The New Interpreter’s Bible")]), _vm._v(". 12 vols. Nashville: Abingdon, 1994–2004")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICNT")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NIDNTTE")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Silva, Moisés, ed. "), _c('em', [_vm._v("New International Dictionary of New Testament Theology and Exegesis")]), _vm._v(". 5 vols. Grand Rapids: Zondervan, 2014")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NovT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NovTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Novum Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RIC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Roman Imperial Coinage: Volume 1—From 31 BC to AD 69.")]), _vm._v(" Revised ed. Edited by C. H. V. Sutherland and R. A. G. Carson. London: Spink and Son, 1984")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RPC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Roman Provincial Coinage.")]), _vm._v(" Edited by Andrew Burnett et al. London: British Museum Press; Paris: Bibliothèque Nationale, 1992–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Reformed Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBL")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLRBS")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Resources for Biblical Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SemeiaSt")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Semeia Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SJT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scottish Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SNTSU")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studien zum Neuen Testament und seiner Umwelt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SSA")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Semantic and Structural Analysis Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SymS")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Symposium Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TAPA")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Transactions of the American Philological Association")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TAPS")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Transactions of the American Philosophical Society")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TBLNT")]), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Coenen, Lothar, and Klaus Haacker, eds. "), _c('em', [_vm._v("Theologisches Begriffslexikon zum Neuen Testament")]), _vm._v(". Rev. ed. in one vol. (“3. Sonderauflage”; slightly supplemented version of the revised two-volume edition of 1997/2000). Wuppertal: Brockhaus, 2014")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kittel, Gerhard, and Gerhard Friedrich, eds. "), _c('em', [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(". Translated by Geoffrey W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–1976")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TENTS")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Texts and Editions for New Testament Study")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TLG")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Thesaurus Linguae Graecae: Canon of Greek Authors and Works.")]), _vm._v(" Edited by Luci Berkowitz and Karl A. Squitier. 3rd ed. New York: Oxford University Press, 1990")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TLZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theologische Literaturzeitung")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TWNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kittel, Gerhard, and Gerhard Friedrich, eds. "), _c('em', [_vm._v("Theologische Wörterbuch zum Neuen Testament")]), _vm._v(". Stuttgart: Kohlhammer, 1932–1979")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TynBul")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WUNT")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("YCS")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Yale Classical Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29944609","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Abbreviation.vue
// module id = 81
// module chunks = 0